import { z } from 'zod';
import { EfemAdapterKeySchema } from './efem-adapter-registry.js';
const BaseResponseSchema = z.object({
    success: z.boolean(),
    message: z.string().optional(),
});
export const EfemAdapterAssignmentSchema = z.object({
    efemAdapterKey: EfemAdapterKeySchema,
    assignedAt: z.string().datetime(),
    assignedBy: z.string().min(1),
    notes: z.string().max(500).optional(),
});
export const PutEfemAdapterAssignmentBodySchema = z.object({
    efemAdapterKey: EfemAdapterKeySchema,
    notes: z.string().max(500).optional(),
});
export const EfemAdapterRegistryEntrySummarySchema = z.object({
    efemAdapterKey: z.string(),
    displayName: z.string(),
    thingGroupSuffix: z.string(),
    greengrassComponentName: z.string(),
    isDevSimulator: z.boolean().optional(),
});
export const EfemAdapterRegistryListResponseSchema = BaseResponseSchema.extend({
    data: z.object({ entries: z.array(EfemAdapterRegistryEntrySummarySchema) }),
});
export const EfemAdapterAssignmentResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        serialNumber: z.string(),
        assignment: EfemAdapterAssignmentSchema.nullable(),
    }),
});
//# sourceMappingURL=efem-adapter-assignment-schemas.js.map